import DateHelper from "core/DateHelper";

// The API applies this calendar-date rule to grid, summary and export searches,
// including reference-number searches. Do not mutate the date-picker values.
export function validateETransferSearchDates(model) {
  const start = model.SearchStartDate ? DateHelper.ToMoment(model.SearchStartDate) : null;
  const end = model.SearchEndDate ? DateHelper.ToMoment(model.SearchEndDate) : null;

  if (!start?.isValid()) {
    return { field: "SearchStartDate", message: "Start Date is required and must be valid" };
  }
  if (!end?.isValid()) {
    return { field: "SearchEndDate", message: "End Date is required and must be valid" };
  }

  const days = end.startOf("day").diff(start.startOf("day"), "days");
  if (days < 0) {
    return { field: "SearchEndDate", message: "End Date must be on or after Start Date" };
  }
  if (days > 30) {
    return {
      field: "SearchEndDate",
      message: "Difference between Start Date and End Date cannot be longer than 30 days",
    };
  }
  return null;
}

// Keep the reference as text: Int64 values can exceed JavaScript integer precision.
export function isETransferReferenceNumberAllowed({ value }) {
  const maximum = "9223372036854775807";
  return value === "" || (/^\d+$/.test(value) &&
    (value.length < maximum.length ||
      (value.length === maximum.length && value <= maximum)));
}
